(() => {
  const init = (root) => {
    if (root.dataset.gdReady) return;
    root.dataset.gdReady = 'true';
    const grid = root.querySelector('[data-gd-artist-grid]');
    const cards = Array.from(root.querySelectorAll('[data-gd-artist-card]'));
    const input = root.querySelector('[data-gd-artist-search]');
    const available = root.querySelector('[data-gd-artist-available]');
    const count = root.querySelector('[data-gd-artist-count]');
    const empty = root.querySelector('[data-gd-artist-empty]');
    if (!grid || !input || !cards.length) return;
    let catalog = [];
    try { catalog = JSON.parse(root.querySelector('[data-gd-roster-catalog]')?.textContent || '[]'); } catch (_) {}
    const workLabel = root.querySelector('[data-gd-roster-work-label]')?.textContent.trim() || '';
    cards.forEach(card => {
      const profile = card.querySelector('.gd-artist-card__link');
      const handle = card.dataset.artistHandle || profile?.getAttribute('href')?.split('/').filter(Boolean).pop();
      const works = catalog.filter(work => work.artists.includes(handle) || (handle === 'zach' && work.alt?.startsWith('REDACTED, ')));
      if (!works.length) return;
      card.dataset.available = 'true';
      const categories = [...new Set(works.map(work => work.category).filter(value => value && value !== 'UNKNOWN'))].slice(0,2);
      const names = {'Paintings':'Painting','Sculpture & objects':'Sculpture and objects','Mixed media & other works':'Mixed media'};
      const medium = card.querySelector('.gd-artist-card__meta');
      if (medium && categories.length) medium.textContent = categories.map(value => names[value] || value).join(' · ');
      card.dataset.search += ' ' + categories.join(' ');
      const frame = card.querySelector('.gd-artist-card__image');
      const imageWork = works.find(work => work.image);
      if (frame && !frame.querySelector('img') && imageWork) {
        const image = document.createElement('img');
        image.src = imageWork.image;
        image.alt = imageWork.alt;
        image.loading = 'lazy';
        image.width = 960;
        image.height = 960;
        image.sizes = '(min-width:1120px) 23vw, (min-width:780px) 31vw, 46vw';
        image.srcset = [240,360,480,720,960].map(width => { const url = new URL(imageWork.image, location.origin); url.searchParams.set('width',String(width)); return url.href+' '+width+'w'; }).join(', ');
        frame.replaceChildren(image);
        frame.classList.add('gd-artist-card__image--art');
        card.dataset.hasImage = 'true';
      }
      let link = card.querySelector('.gd-artist-card__available');
      if (!link) { link = document.createElement('a'); link.className = 'gd-artist-card__available'; card.append(link); }
      link.href = profile.getAttribute('href').split('#')[0] + '#artist-collect';
      link.textContent = workLabel + '';
    });
    const original = cards.slice();
    const params = new URLSearchParams(location.search);
    input.value = (params.get('artist_search') || '').slice(0, 200);
    available.checked = params.get('available') === '1';
    const saveView = () => {
      const url = new URL(location.href);
      const state = {artist_search: input.value.trim(), available: available.checked ? '1' : '', artist_view: root.dataset.view === 'index' ? 'index' : ''};
      Object.entries(state).forEach(([key, value]) => value ? url.searchParams.set(key, value) : url.searchParams.delete(key));
      try { history.replaceState(history.state, '', url); } catch (_) {}
    };
    const normalise = (value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
    root.querySelector('[data-gd-discovery-tools]').hidden = false;
    root.querySelector('[data-gd-results-wrap]').hidden = false;
    root.querySelector('[data-gd-available-label]').hidden = !cards.some((card) => card.dataset.available === 'true');
    const update = () => {
      const query = normalise(input.value);
      let visible = 0;
      cards.forEach((card) => {
        const matches = normalise(card.dataset.search || '').includes(query) && (!available.checked || card.dataset.available === 'true') && (root.dataset.view === 'index' || card.dataset.hasImage !== 'false');
        card.hidden = !matches;
        if (matches) visible++;
      });
      count.textContent = (visible === 1 ? count.dataset.one : count.dataset.many).replace('[count]', String(visible));
      empty.hidden = visible !== 0;
      root.querySelector('[data-gd-results-wrap] [data-gd-artist-reset]').hidden = !query && !available.checked;
      saveView();
    };
    input.addEventListener('input', update);
    available.addEventListener('change', update);
    root.querySelectorAll('[data-gd-artist-reset]').forEach((button) => button.addEventListener('click', () => {
      input.value = '';
      available.checked = false;
      update();
      input.focus({preventScroll: true});
    }));
    root.querySelectorAll('[data-gd-artist-view]').forEach((button) => button.addEventListener('click', () => {
      const view = button.dataset.gdArtistView;
      root.dataset.view = view;
      root.querySelectorAll('[data-gd-artist-view]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      const sorted = view === 'index' ? cards.slice().sort((a, b) => (a.dataset.name || 'REDACTED').localeCompare(b.dataset.name || 'REDACTED', undefined, {sensitivity: 'base'})) : original;
      const fragment = document.createDocumentFragment();
      sorted.forEach((card) => fragment.appendChild(card));
      grid.appendChild(fragment);
      update();
    }));
    if (params.get('artist_view') === 'index') root.querySelector('[data-gd-artist-view="index"]').click();
    update();
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-gd-inquiry-interest]');
    if (!link) return;
    const select = document.querySelector('#artist-inquiry select[name="contact[Interest]"]');
    if (select && Array.from(select.options).some((option) => option.value === link.dataset.gdInquiryInterest)) {
      select.value = link.dataset.gdInquiryInterest;
      select.dispatchEvent(new Event('change', {bubbles: true}));
    }
  });
  const start = (scope) => scope.querySelectorAll('[data-gd-discovery]').forEach(init);
  start(document);
  document.addEventListener('shopify:section:load', (event) => start(event.target));
})();
